import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

import { getContent } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import WhiteContainer from '../../../components/Container/WhiteContainer';
import MasterDataDataGroupButton from '../../../components/MasterData/MasterDataDataGroupButton';
import API_MASTER_DATA from '../../../api/apiMasterData';

class DataScopeAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customer: {
                page: 1,
                limit: 100,
                data: [],
                value: [],
                selected: [],
                disabled: false,
            },
            principal: {
                page: 1,
                limit: 100,
                data: [],
                value: [],
                selected: [],
                disabled: false,
            },
        }
    }

    getListCustomer = () => {
        API_MASTER_DATA.getListDistributorDataGroup(this.state.customer.page, this.state.customer.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let customerList = getContent(res).map(customer => ({
                        value: customer.user_nexcare_id,
                        label: customer.customer_name
                    }))
                    this.setState({
                        customer: {
                            ...this.state.customer,
                            data: customerList
                        }
                    })
                }
            })
    }

    getSearchCustomer = keyword => {
        API_MASTER_DATA.getSearchDistributorDataGroup(this.state.customer.page, this.state.customer.limit, keyword, this.props.token)
            .then(res => {
                let customerList = getContent(res).map(customer => ({
                    value: customer.user_nexcare_id,
                    label: customer.customer_name
                }))
                this.setState({
                    customer: {
                        ...this.state.customer,
                        data: customerList
                    }
                });
            })
    }

    getListPrincipal = () => {
        API_MASTER_DATA.getListPrincipalDataGroup(this.state.principal.page, this.state.principal.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let principalList = getContent(res).map(principal => ({
                        value: principal.user_nexcare_id,
                        label: principal.customer_name
                    }))
                    this.setState({
                        principal: {
                            ...this.state.principal,
                            data: principalList
                        }
                    })
                }
            })
    }

    getSearchPrincipal = keyword => {
        API_MASTER_DATA.getSearchPrincipalDataGroup(this.state.principal.page, this.state.principal.limit, keyword, this.props.token)
            .then(res => {
                let principalList = getContent(res).map(principal => ({
                    value: principal.user_nexcare_id,
                    label: principal.customer_name
                }))
                this.setState({
                    principal: {
                        ...this.state.principal,
                        data: principalList
                    }
                });
            })
    }

    handleChangeCustomer = async data => {
        await this.setState({
            customer: {
                ...this.state.customer,
                selected: data.map(data => ('nexsoft.user_customer.cust:' + data.value)),
                value: data
            }
        })
        this.props.handleChangeDataScope(this.state.customer.selected, this.state.principal.selected)
    }

    handleSearchCustomer = keyword => {
        if (keyword !== '') {
            return this.getSearchCustomer(keyword);
        }
        return this.getListCustomer();
    }

    handleChangePrincipal = async data => {
        await this.setState({
            principal: {
                ...this.state.principal,
                selected: data.map(data => ('nexsoft.user_customer.pr:' + data.value)),
                value: data
            }
        })
        this.props.handleChangeDataScope(this.state.customer.selected, this.state.principal.selected)
    }

    handleSearchPrincipal = keyword => {
        if (keyword !== '') {
            return this.getSearchPrincipal(keyword);
        }
        return this.getListPrincipal();
    }

    handleCheckboxCustomer = async () => {
        await this.setState({
            customer: {
                ...this.state.customer,
                value: [],
                selected: ['nexsoft.user_customer.cust:all'],
                disabled: !this.state.customer.disabled
            }
        })
        this.props.handleChangeDataScope(this.state.customer.selected, this.state.principal.selected)
    }

    handleCheckboxPrincipal = async () => {
        await this.setState({
            principal: {
                ...this.state.principal,
                value: [],
                selected: ['nexsoft.user_customer.pr:all'],
                disabled: !this.state.principal.disabled
            }
        })
        this.props.handleChangeDataScope(this.state.customer.selected, this.state.principal.selected)
    }

    componentDidMount() {
        this._isMounted = true;

        this.getListCustomer();
        this.getListPrincipal();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const animatedComponents = makeAnimated();

        return (
            <div>
                <MasterDataDataGroupButton
                    dataScopePage={this.props.dataScopePage}
                    handleDataGroup={this.props.handleDataGroup}
                    handleDataScope={this.props.handleDataScope}
                />
                <WhiteContainer>
                    <div className="flex">
                        <div className="w-1/2 p-10 kiri">
                            <div className="flex justify-between w-full mb-5">
                                <div className="w-1/6 pr-5 text-right">
                                    <label className="select-none font-medium" htmlFor="mlscustomername">Nama Distributor</label>
                                </div>
                                <div className="w-5/6">
                                    <Select
                                        id="mlscustomername"
                                        closeMenuOnSelect={false}
                                        components={animatedComponents}
                                        placeholder="Pilih Distributor"
                                        isMulti
                                        options={this.state.customer.data}
                                        value={this.state.customer.value}
                                        isDisabled={this.state.customer.disabled}
                                        onChange={this.handleChangeCustomer}
                                        onInputChange={this.handleSearchCustomer}
                                    />
                                    <div className="mt-5 font-medium">
                                        <input type="checkbox" id="ckballcustomer" className="mr-2" onChange={this.handleCheckboxCustomer} />
                                        <label htmlFor="ckballcustomer" className="select-none">Terapkan Semua</label>
                                    </div>
                                </div>
                            </div>
                            <div className="flex justify-between w-full mb-5">
                                <div className="w-1/6 pr-5 text-right">
                                    <label className="select-none font-medium" htmlFor="mlsprincipalname">Nama Principal</label>
                                </div>
                                <div className="w-5/6">
                                    <Select
                                        id="mlsprincipalname"
                                        closeMenuOnSelect={false}
                                        components={animatedComponents}
                                        placeholder="Pilih Principal"
                                        isMulti
                                        options={this.state.principal.data}
                                        value={this.state.principal.value}
                                        isDisabled={this.state.principal.disabled}
                                        onChange={this.handleChangePrincipal}
                                        onInputChange={this.handleSearchPrincipal}
                                    />
                                    <div className="mt-5 font-medium">
                                        <input type="checkbox" id="ckballprincipal" className="mr-2" onChange={this.handleCheckboxPrincipal} />
                                        <label htmlFor="ckballprincipal" className="select-none">Terapkan Semua</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="absolute bottom-5 right-5">
                        <button type="button" id="btncancel" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-2 mt-3 mr-2" onClick={() => this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_DATA_GROUP)}>Batal</button>
                        <button type="button" id="btnsave" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-2 mt-3 ml-2" onClick={() => this.props.handleSubmit()}>Simpan</button>
                    </div>
                </WhiteContainer>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

export default withRouter(connect(mapStateToProps, null)(DataScopeAdd));